const AuthHeading = ({ title, subTitle, onClickTitle, onClick }) => (
  <div className="my-4 mb-4">
    <p className="font-bold font-sans text-2xl rtl:text-xl text-black">
      {title}
    </p>
    <p className="font-normal text-brandGray2">
      {subTitle} &nbsp;
      <span
        className="underline font-sans font-normal text-black cursor-pointer"
        onClick={onClick}>
        {onClickTitle}
      </span>
    </p>
  </div>
);

export default AuthHeading;
